"use client"

import { createContext, useContext, useState } from "react"

interface ActiveNavContextType {
   activeNavHref: string | null
   setActiveNavHref: (href: string | null) => void

   activeCategory: string | null
   setActiveCategory: (category: string | null) => void
}

const ActiveNavContext = createContext<ActiveNavContextType>({
   activeNavHref: null,
   setActiveNavHref: () => {},

   activeCategory: null,
   setActiveCategory: () => {},
})

export function ActiveNavProvider({ children }: { children: React.ReactNode }) {
   const [activeNavHref, setActiveNavHref] = useState<string | null>(null)
   const [activeCategory, setActiveCategory] = useState<string | null>(null)

   return (
      <ActiveNavContext.Provider
         value={{
            activeNavHref,
            setActiveNavHref,

            activeCategory,
            setActiveCategory,
         }}
      >
         {children}
      </ActiveNavContext.Provider>
   )
}

export function useActiveNav() {
   return useContext(ActiveNavContext)
}
